// Cookiebot + Microsoft Clarity Integration for Shopify
(function() {
    'use strict';
    
    // Your Clarity tracking ID
    const CLARITY_ID = 's8tbfbl924';
    
    /**
     * Loads Microsoft Clarity tracking script
     */
    function loadClarity() {
        if (!window.clarity && !document.querySelector('[src*="clarity.ms"]')) {
            //console.log('Loading Microsoft Clarity via Cookiebot consent...');
            (function(c,l,a,r,i,t,y){
                c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
                t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
                y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
            })(window, document, "clarity", "script", CLARITY_ID);
        }
    }
    
    /**
     * Check if Cookiebot has statistics/analytics consent
     */
    function hasCookiebotAnalyticsConsent() {
        // Check if Cookiebot is loaded
        if (typeof window.Cookiebot !== 'undefined') {
            // Check if statistics cookies are consented
            return window.Cookiebot.consent.statistics === true;
        }
        
        // Fallback: check the Cookiebot consent cookie
        const cookieValue = document.cookie
            .split('; ')
            .find(row => row.startsWith('CookieConsent='));
            
        if (cookieValue) {
            const consentString = cookieValue.split('=')[1];
            // Cookiebot stores consent in format: {necessary:true, statistics:true, marketing:true, preferences:true}
            try {
                // Simple check for statistics consent in the cookie string
                return consentString.includes('statistics:true');
            } catch (e) {
                console.warn('Could not parse Cookiebot consent cookie:', e);
            }
        }
        
        return false;
    }
    
    /**
     * Initialize Clarity if consent is already given
     */
    function initializeClarity() {
        if (hasCookiebotAnalyticsConsent()) {
            loadClarity();
        }
    }
    
    /**
     * Set up Cookiebot event listeners
     */
    function setupCookiebotListeners() {
        // Method 1: Listen for Cookiebot's window events
        window.addEventListener('CookiebotOnAccept', function() {
            //console.log('Cookiebot accepted - checking statistics consent');
            if (hasCookiebotAnalyticsConsent()) {
                loadClarity();
            }
        });
        
        window.addEventListener('CookiebotOnDecline', function() {
            console.log('Cookiebot declined - Clarity will not load');
        });
        
        // Method 2: Listen for clicks on Cookiebot buttons
        document.addEventListener('click', function(event) {
            // Check for "Allow all" button
            if (event.target && (
                event.target.id === 'CybotCookiebotDialogBodyLevelButtonLevelOptinAllowAll' ||
                event.target.classList.contains('cookiebanner__buttons__accept')
            )) {
                console.log('Allow all clicked - loading Clarity');
                setTimeout(loadClarity, 100);
            }
            
            // Check for "Allow selection" button
            if (event.target && (
                event.target.id === 'CybotCookiebotDialogBodyLevelButtonLevelOptinAllowallSelection' ||
                event.target.classList.contains('cookiebanner__accept-selection')
            )) {
                console.log('Allow selection clicked - checking statistics consent');
                setTimeout(function() {
                    if (hasCookiebotAnalyticsConsent()) {
                        loadClarity();
                    }
                }, 100);
            }
        });
        
        // Method 3: Monitor for consent changes via mutation observer
        const observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.type === 'childList' || mutation.type === 'attributes') {
                    // Check if the cookie banner is no longer visible (consent given)
                    const banner = document.getElementById('CookieBanner');
                    if (banner && !banner.classList.contains('is-visible-cookie-banner')) {
                        if (hasCookiebotAnalyticsConsent() && !window.clarity) {
                            loadClarity();
                        }
                    }
                }
            });
        });
        
        // Start observing the cookie banner
        const banner = document.getElementById('CookieBanner');
        if (banner) {
            observer.observe(banner, {
                attributes: true,
                childList: true,
                subtree: true,
                attributeFilter: ['class', 'style']
            });
        }
    }
    
    /**
     * Poll for Cookiebot to be loaded, then set up listeners
     */
    function waitForCookiebot() {
        const maxAttempts = 50; // 5 seconds max
        let attempts = 0;
        
        const checkInterval = setInterval(function() {
            attempts++;
            
            // Check if Cookiebot elements exist
            const cookieBanner = document.getElementById('CookieBanner');
            
            if (cookieBanner || typeof window.Cookiebot !== 'undefined' || attempts >= maxAttempts) {
                clearInterval(checkInterval);
                
                if (cookieBanner || typeof window.Cookiebot !== 'undefined') {
                    //console.log('Cookiebot detected - setting up Clarity integration');
                    setupCookiebotListeners();
                    initializeClarity(); // Check if consent already exists
                } else {
                    console.warn('Cookiebot not detected after waiting');
                }
            }
        }, 100);
    }
    
    /**
     * Initialize the integration
     */
    function initialize() {
        // Check if Cookiebot is already loaded
        if (typeof window.Cookiebot !== 'undefined' || document.getElementById('CookieBanner')) {
            setupCookiebotListeners();
            initializeClarity();
        } else {
            // Wait for Cookiebot to load
            waitForCookiebot();
        }
    }
    
    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initialize);
    } else {
        initialize();
    }
    
    // Also try to initialize after a short delay (in case Cookiebot loads async)
    setTimeout(initialize, 1000);
    
    /*
    // Debug helper (remove in production)
    window.clarityDebug = {
        hasConsent: hasCookiebotAnalyticsConsent,
        loadClarity: loadClarity,
        isLoaded: function() { return !!window.clarity; },
        cookiebotLoaded: function() { return typeof window.Cookiebot !== 'undefined'; }
    };
    */
    
})();